<template>
  <v-navigation-drawer
    width="550px"
    absolute
    persistent
  >
    <v-btn
      color="transparent"
      depressed
      class="back-button"
      @click="onBackButtonPressed"
      @mouseover="showBackButton = true"
      @mouseleave="showBackButton = false"
    >
      <v-icon
        left
        class="pa-0"
      >
        mdi-arrow-left
      </v-icon>
      {{ getBackButtonText }}
    </v-btn>
    <div style="height: 2%" />
    <div class="main_page_content">
      <PreviousComputationsComponent />
      <div style="height: 2%" />
      <VoyageDetailsLoadingComponent
        v-if="fetchSolutionsLoading && !recalculationLoading"
      />
      <div
        v-else-if="recalculationLoading"
        class="loader_container"
      >
        <CircularCalculationStateLoader
          :calculation-state="recalculationState"
          :size="100"
        />
      </div>
      <VoyageDetailsFailedComponent
        v-else-if="showError && !recalculationLoading"
        :message="failedText"
      />
      <VoyageDetailsSuccessComponent v-else />
    </div>

    <RequestResponseSnackBar
      v-model="showErrorSnackBar"
      :value="showErrorSnackBar"
      :text="calculationFailedErrorMessage"
      color="red"
      :timeout="3000"
    />

    <template v-slot:append>
      <div class="navigation_drawer_prepend_export">
        <ExportVoyageData v-if="showExportButton" />
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import VoyageDetailsSuccessComponent from "./LoadingView.vue";
import VoyageDetailsLoadingComponent from "./SuccessView.vue";
//import VoyageDetailsSuccessComponent from "./SuccessView.vue";
//import VoyageDetailsLoadingComponent from "./LoadingView.vue";
import VoyageDetailsFailedComponent from "./FailedView.vue";
import ExportVoyageData from "./components/ExportVoyageData.vue";
import PreviousComputationsComponent from "./components/PreviousComputations.vue";
import RequestResponseSnackBar from "../../components/RequestResponseSnackBar.vue";
import CircularCalculationStateLoader from "../../components/CircularCalculationStateLoader.vue";

export default {
  name: "VoyageDetails",
  components: {
    VoyageDetailsSuccessComponent,
    VoyageDetailsLoadingComponent,
    ExportVoyageData,
    PreviousComputationsComponent,
    VoyageDetailsFailedComponent,
    RequestResponseSnackBar,
    CircularCalculationStateLoader,
  },
  data: function () {
    return {
      showBackButton: false,
      showErrorSnackBar: false,
    };
  },
  computed: {
    ...mapState("weatherRouting/voyageDetailsModule", [
      "fetchSolutionsLoading",
      "recalculationLoading",
      "voyageSolutions",
      "recalculationError",
      "selectedComputation",
      "recalculationState",
    ]),
    ...mapGetters("weatherRouting/voyageDetailsModule", [
      "fetchRequestFailed",
      "noVoyageSolutions",
      "recalculationFailed",
      "showRecalculationLoading",
    ]),
    getBackButtonText() {
      return this.showBackButton ? "Back" : "";
    },
    showExportButton() {
      return !(
        this.fetchRequestFailed ||
        this.recalculationLoading ||
        this.fetchSolutionsLoading ||
        this.noVoyageSolutions
      );
    },
    showError() {
      return this.fetchRequestFailed || this.noVoyageSolutions;
    },
    failedText() {
      return this.fetchRequestFailed
        ? "Could not fetch voyage solutions"
        : "No solutions for that computation";
    },
    calculationFailedErrorMessage() {
      return `Calculation failed : ${this.recalculationError}`;
    },
  },
  watch: {
    recalculationFailed: {
      handler(value) {
        this.showErrorSnackBar = value;
      },
      deep: true,
    },
  },
  async created() {
    const voyageId = this.$route.params.voyageId;
    await this.getVoyageComputations(voyageId);
    await this.checkSelectedComputationState(voyageId);
  },
  methods: {
    ...mapActions("weatherRouting/voyageDetailsModule", [
      "getVoyageSolutions",
      "getVoyageComputations",
      "checkSelectedComputationState",
    ]),
    async onBackButtonPressed() {
      this.$store.commit("weatherRouting/voyageDetailsModule/RESET_STATE");
      this.$store.commit("weatherRouting/weatherRoutingMapModule/RESET_STATE");
      await this.$store.dispatch(
        "weatherRouting/voyagesModule/fetchAllVoyages"
      );
      this.$router.go(-1);
      this.$store.commit(
        "weatherRouting/voyageDetailsModule/RESET_CALCULATION_INTERVAL_AND_TIMEOUT"
      );
    },
  },
};
</script>

<style scoped>
.v-navigation-drawer {
  padding: 0 !important;
  background-color: var(--color-bg) !important;
}
.navigation_drawer_prepend_export {
  margin-top: 20px;
  margin-bottom: 30px;
}
.main_page_content {
  height: 80%;
  padding: 0 10px;
  background-color: var(--color-bg);
}
.loader_container {
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.back-button {
  background-color: var(--color-bg) !important;
  color: var(--color-text) !important;
}
</style>
